import Fruits from "../../../../../server/com/silkplm/rpc/healthcheck/fruits/_RpcIndex.js";
import Methods from "../../../../../server/com/silkplm/rpc/healthcheck/methods/_RpcIndex.js";
import Transactions from "../../../../../server/com/silkplm/rpc/healthcheck/transactions/_RpcIndex.js";

import AiApiTest from "../../../../../server/com/silkplm/rpc/healthcheck/AiApiTest.js";
import AsyncApi from "../../../../../server/com/silkplm/rpc/healthcheck/AsyncApi.js";
import BasketApi from "../../../../../server/com/silkplm/rpc/healthcheck/BasketApi.js";
import CalApi from "../../../../../server/com/silkplm/rpc/healthcheck/CalApi.js";
import FilesApi from "../../../../../server/com/silkplm/rpc/healthcheck/FilesApi.js";
import MixedApi from "../../../../../server/com/silkplm/rpc/healthcheck/MixedApi.js";
import Notifications from "../../../../../server/com/silkplm/rpc/healthcheck/Notifications.js";
import OrgEntityApi from "../../../../../server/com/silkplm/rpc/healthcheck/OrgEntityApi.js";
import PrimitivesApi from "../../../../../server/com/silkplm/rpc/healthcheck/PrimitivesApi.js";
import RevRpcApi from "../../../../../server/com/silkplm/rpc/healthcheck/RevRpcApi.js";
import Selenium from "../../../../../server/com/silkplm/rpc/healthcheck/Selenium.js";

class Healthcheck{
    constructor() {
            /** @type {Fruits} */
            this.fruits = new Fruits();
            /** @type {Methods} */
            this.methods = new Methods();
            /** @type {Transactions} */
            this.transactions = new Transactions();

            /** @type {module:src/server/com/silkplm/rpc/healthcheck/AiApiTest.AiApiTest} */
            this.AiApiTest = new AiApiTest();
            /** @type {module:src/server/com/silkplm/rpc/healthcheck/AsyncApi.AsyncApi} */
            this.AsyncApi = new AsyncApi();
            /** @type {module:src/server/com/silkplm/rpc/healthcheck/BasketApi.BasketApi} */
            this.BasketApi = new BasketApi();
            /** @type {module:src/server/com/silkplm/rpc/healthcheck/CalApi.CalApi} */
            this.CalApi = new CalApi();
            /** @type {module:src/server/com/silkplm/rpc/healthcheck/FilesApi.FilesApi} */
            this.FilesApi = new FilesApi();
            /** @type {module:src/server/com/silkplm/rpc/healthcheck/MixedApi.MixedApi} */
            this.MixedApi = new MixedApi();
            /** @type {module:src/server/com/silkplm/rpc/healthcheck/Notifications.Notifications} */
            this.Notifications = new Notifications();
            /** @type {module:src/server/com/silkplm/rpc/healthcheck/OrgEntityApi.OrgEntityApi} */
            this.OrgEntityApi = new OrgEntityApi();
            /** @type {module:src/server/com/silkplm/rpc/healthcheck/PrimitivesApi.PrimitivesApi} */
            this.PrimitivesApi = new PrimitivesApi();
            /** @type {module:src/server/com/silkplm/rpc/healthcheck/RevRpcApi.RevRpcApi} */
            this.RevRpcApi = new RevRpcApi();
            /** @type {module:src/server/com/silkplm/rpc/healthcheck/Selenium.Selenium} */
            this.Selenium = new Selenium();
    }
}

export default Healthcheck;

